import { useQuery } from "@tanstack/react-query";
import { gql } from "graphql-request";

import { CountryWeSellTo } from "../types";
import { axiosQuery } from "../utils/axiosHelpers";

export interface CountriesWeSellTo {
  countries: CountryWeSellTo[];
}

interface CountriesWeSellToResponse {
  countriesWeSellMembership: CountryWeSellTo[];
}

const SELL_MEMBERSHIP_TO_COUNTRIES_QUERY = gql`
  query CountriesWeSellMembership {
    countriesWeSellMembership {
      countryCode
      isoAlpha3Code
      name
      regions {
        label
        value
      }
    }
  }
`;

export const useGetSellToCountries = () =>
  useQuery<CountryWeSellTo[]>({
    queryKey: ["countriesWeSellMembership"],
    queryFn: async () => {
      const response = await axiosQuery<CountriesWeSellToResponse>(
        "CountriesWeSellMembership",
        SELL_MEMBERSHIP_TO_COUNTRIES_QUERY,
      );
      return response.countriesWeSellMembership;
    },
    retry: false,
    staleTime: Infinity,
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
